import useAuthToken from './useAuthToken';

export {useAuthToken};

export default useAuthToken;
